import React from "react";

const TestiCard = (props) => {
  const { src, des, name, location } = props;

  return (
      <div className="testimonial">
          <div className="testimonial__image">
              <img src={src} alt="Testimonial Image" />
          </div> 
          <div className="testimonial__quote"> 
              {des}
          </div>  
          <div className="testimonial__credit">
            <div className="testimonial__author">
            {name}
            </div>
            <div className="testimonial__location">
              {location}
            </div>
           </div>
                       
      </div>
  );
};

export default TestiCard;
